<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="200 Casseroles"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index">200 Casseroles</a></h1><h3 class="author"><a id="index">Stephanie Ashcraft and Janet Eyring</a></h3><a id="index"><img alt="Gibbs Smith Logo" src="images/logo.jpg"/></a></div><div class="verso"><p class="versotitle"><a id="index">200 Casseroles</a></p><p><a id="index">Digital Edition 1.0</a></p><p class="copyright"><a id="index">Text © 2011 Stephanie Ashcraft and Janet Eyring</a></p><p><a id="index">All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.</a></p><p class="nobreak"><a id="index">Gibbs Smith</a></p><p class="nobreak"><a id="index">P.O. Box 667</a></p><p><a id="index">Layton, Utah 84041</a></p><p class="nobreak"><a id="index">Orders: 1.800.835.4993</a></p><p><a id="index">www.gibbs-smith.com</a></p><p><a id="index">ISBN: 978-1-4236-2335-9</a></p></div></div><div class="frontmatter"><div class="dedication" title="Dedication"><p><a id="index">To my family. —S.A.</a></p><p><a id="index">To my husband, Sean, thank you for your computer and eagle-eye proofreading skills. —J.E.</a></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?8c7828c4